export function unwrapListResponse(response: unknown): any[] {
  if (Array.isArray(response) && Array.isArray(response[0])) {
    return response[0];
  }
  if (Array.isArray(response)) {
    return response;
  }
  if (response && typeof response === 'object') {
    const record = response as { data?: unknown; items?: unknown };
    if (Array.isArray(record.data)) return record.data;
    if (Array.isArray(record.items)) return record.items;
  }
  return [];
}

export function serviceOrderBelongsToCustomer(order: any, customerId: string): boolean {
  if (!customerId || !order) return false;
  const id = String(customerId);
  return [order.customerId, order.customer?.id, order.customers?.id].some(
    (value) => value != null && String(value) === id
  );
}

export function formatCustomerRecordDate(value: unknown): string {
  if (value == null || value === '') return '-';
  if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}/.test(value)) {
    return value.slice(0, 10);
  }
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [year, month, day] = value.slice(0, 10).split('-');
    return `${day}/${month}/${year}`;
  }
  const date = new Date(value as string);
  if (Number.isNaN(date.getTime())) return '-';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${date.getFullYear()}`;
}

export interface CustomerServiceOrderRow {
  id: string;
  code: string;
  title: string;
  type: string;
  status: string;
  createdAt: string;
}

export function toCustomerServiceOrderRow(order: any): CustomerServiceOrderRow {
  return {
    id: order?.id,
    code: order?.code != null && order.code !== '' ? String(order.code) : '-',
    title: order?.title || order?.name || 'OS sem título',
    type: order?.fileType || '-',
    status: order?.status || '-',
    createdAt: formatCustomerRecordDate(order?.createdAt),
  };
}

export function contractStatusLabel(contract: {
  status?: string;
  localGeneration?: boolean;
}): string {
  if (contract?.localGeneration && contract.status !== 'signed') {
    return 'NÃO ENVIADO P/ ASSINATURA';
  }
  const statusMap: Record<string, string> = {
    processing: 'PROCESSANDO',
    waiting_for_signatories: 'AGUARD. SIGNATÁRIOS',
    waiting_for_signatures: 'AGUARD. ASSINATURAS',
    link_opened: 'VISUALIZADO',
    signed: 'ASSINADO',
    archived: 'ARQUIVADO',
    canceled: 'CANCELADO',
    editing: 'EDITANDO',
    pending: 'PENDENTE',
  };
  return statusMap[(contract?.status || '').toLowerCase()] || 'DESCONHECIDO';
}
